import Cookies from "universal-cookie";

var cookies = new Cookies();
export const HEADERS = {
    'Content-Type': 'application/json'
}

export const USUARIO_ID = {
    UsuarioId: cookies.get('usuarioId'),
}

export const SDT_SESSION = {
    UsuarioId: cookies.get('usu_id'),
    Mb_epr_cod: cookies.get('usu_codEmp'),
    SesionToken: cookies.get('usu_token')
}